export default "/assets/images/mila-feed-14.mp4?95f3dcd3a5cad7d2195073f8d0c35148";